var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fy1H6Fvu1sME61ttGHyBQ"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sipec-frontend@webranking-srl"]={id:"fy1H6Fvu1sME61ttGHyBQ"};
      